import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { activityLogsApi } from '../../services/api'
import LoadingSpinner from '../../components/ui/LoadingSpinner'
import Card from '../../components/ui/Card'
import { formatDateTime } from '../../utils/date'
import {
  activityActionBadgeClass,
  activityActionLabel,
  activityModuleLabel,
  activitySubjectLabel,
} from '../../utils/activityLog'

export default function AdminActivityLogs() {
  const { t } = useTranslation()
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    activityLogsApi
      .getAll({ per_page: 100 })
      .then(({ data }) => setLogs(data.data || data || []))
      .catch(() => setLogs([]))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <LoadingSpinner className="py-20" />

  return (
    <div>
      <h1 className="mb-2 text-3xl font-bold text-primary">{t('admin.activity.title')}</h1>
      <p className="mb-8 text-text/60">{t('admin.activity.subtitle')}</p>

      <Card padding={false} className="overflow-x-auto">
        <table className="min-w-full text-start text-sm">
          <thead className="border-b border-border bg-primary/5">
            <tr>
              <th className="px-5 py-3.5 text-start font-semibold text-primary">
                {t('admin.activity.page')}
              </th>
              <th className="px-5 py-3.5 text-start font-semibold text-primary">
                {t('admin.activity.action')}
              </th>
              <th className="px-5 py-3.5 text-start font-semibold text-primary">
                {t('admin.activity.user')}
              </th>
              <th className="px-5 py-3.5 text-start font-semibold text-primary">
                {t('admin.activity.time')}
              </th>
            </tr>
          </thead>
          <tbody>
            {logs.length === 0 ? (
              <tr>
                <td colSpan={4} className="px-5 py-12 text-center text-text/50">
                  {t('admin.activity.empty')}
                </td>
              </tr>
            ) : (
              logs.map((log) => (
                <tr key={log.id} className="border-b border-border/60 last:border-0 hover:bg-background/40">
                  <td className="px-5 py-3.5 align-top font-medium text-text">
                    {activityModuleLabel(log.module, t)}
                  </td>
                  <td className="px-5 py-3.5 align-top">
                    <div className="flex flex-wrap items-center gap-2">
                      <span
                        className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${activityActionBadgeClass(log.action)}`}
                      >
                        {activityActionLabel(log.action, t)}
                      </span>
                      {activitySubjectLabel(log) ? (
                        <span className="font-medium text-text">{activitySubjectLabel(log)}</span>
                      ) : null}
                    </div>
                  </td>
                  <td className="px-5 py-3.5 align-top text-text/80">
                    {log.user?.name || log.user_name || t('admin.activity.unknownUser')}
                  </td>
                  <td className="px-5 py-3.5 align-top whitespace-nowrap text-text/60">
                    {formatDateTime(log.created_at)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </Card>
    </div>
  )
}
